import { LOGIN_SCOPES_ARRAY } from '../constants'

/**
 * Build the OAuth authorize URL with the full set of scopes required by the portal.
 * Always use this instead of assembling query strings manually so bookmarked or
 * outdated links cannot omit scopes (e.g. notification:subscribe).
 */
export function buildOAuthAuthorizeUrl(state: string): string {
  const params = new URLSearchParams({
    client_id: process.env.REACT_APP_OAUTH_CLIENT_ID ?? '',
    response_type: 'code',
    scope: LOGIN_SCOPES_ARRAY.join(' '),
    state,
  })

  return `${process.env.REACT_APP_API_URL}/oauth/authorize?${params.toString()}`
}

export function redirectToOAuthAuthorize(state: string): void {
  window.location.replace(buildOAuthAuthorizeUrl(state))
}
